import { Button, Divider, Stack, Typography } from '@mui/material'

import { Header } from './common'

import LottieAnimation from '@/components/LottieAnimation'
import recordMicAnimation from '@/assets/app_art/record-animation.json'

function RecordingStep(props: { onClose: () => void; recordingState: string; handleRecord: () => void; mode: string }) {
  const { recordingState, handleRecord, onClose, mode } = props
  const isAddPronunciation = mode === 'add-pronunciation'

  const isRecording = recordingState === 'recording'

  return (
    <Stack
      onClick={e => {
        e.stopPropagation()
      }}
    >
      <Header title={isAddPronunciation ? 'Record Pronunciation' : 'Record Audio'} onClose={onClose} />
      <Divider />
      <Stack
        sx={{
          padding: '40px 0px',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <Stack
          alignItems="center"
          bgcolor="rgb(251, 84, 84)"
          borderRadius="50%"
          display="flex"
          height={104}
          justifyContent="center"
          mx="auto"
          my={3}
          width={104}
        />
        {isRecording ? (
          <LottieAnimation
            animationData={recordMicAnimation}
            height="200px"
            style={{
              position: 'absolute',
            }}
            width="200px"
          />
        ) : null}
      </Stack>
      <Stack alignItems="center" direction="row" gap="20px" justifyContent="space-between" padding="12px">
        <Typography sx={{ color: '#000', lineHeight: '20px' }}>
          {isAddPronunciation
            ? 'Replaces the default text-to-speech voice with your voice.'
            : 'Audio recording will be added to your prompt'}
        </Typography>
        <Button
          color={isRecording ? 'secondary' : 'primary'}
          sx={{ flexShrink: 0 }}
          variant="contained"
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
            handleRecord()
          }}
        >
          {isRecording ? 'Stop Recording' : 'Start Recording'}
        </Button>
      </Stack>
    </Stack>
  )
}

export default RecordingStep
